import { render, staticRenderFns } from "./Moment.vue?vue&type=template&id=64b0326d&scoped=true&"
import script from "./Moment.vue?vue&type=script&lang=js&"
export * from "./Moment.vue?vue&type=script&lang=js&"
import style0 from "./Moment.vue?vue&type=style&index=0&id=64b0326d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b0326d",
  null
  
)

export default component.exports